module.exports = "/_next/static/images/11-1-4be331e64fe5cf383456c25f16cea1e6.svg";